// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Lenis from 'lenis';

// ============================================
// Lenis
// ============================================
const lerp = 0.2;
const duration = 1.4;

export let lenis = new Lenis({
  lerp,
  duration,
  smoothWheel: true,
  smoothTouch: false,
});

//初期設定
lenis.on('scroll', ScrollTrigger.update);
const _raf = (time) => lenis.raf(time * 1000);
gsap.ticker.add(_raf);
gsap.ticker.lagSmoothing(1000, 16);

const REINIT_MS = 60 * 1000;
setInterval(() => {
  gsap.ticker.remove(_raf);
  lenis.destroy();

  lenis = new Lenis({
    lerp,
    duration,
    smoothWheel: true,
    smoothTouch: true,
  });

  lenis.on('scroll', () => ScrollTrigger.update());
  gsap.ticker.add(_raf);
  ScrollTrigger.refresh();
}, REINIT_MS);

// ============================================
// ページ内リンク
// ============================================
function lenisPageScroll() {
  const links = document.querySelectorAll('a[href^="#"]:not(.-no-smooth, .l-header__skip-content)');
  if (links.length === 0) return;

  const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');
  const headerHeightNum = headerHeight.split('px')[0];

  links.forEach((target) => {
    target.addEventListener('click', (e) => {
      e.preventDefault();
      let targetLink = target.getAttribute('href');
      if (targetLink === '#') {
        targetLink = 'body';
      }

      lenis.scrollTo(targetLink, {
        offset: Number(headerHeightNum) * -1,
        lerp: 0.2,
        duration: 1.2,
      });
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  gsap.utils.toArray('.js-inview').forEach((el) => {
    ScrollTrigger.create({
      //markers: true,
      trigger: el,
      start: 'top 75%',
      end: 'bottom 75%',
      once: true,
      toggleClass: {
        targets: el,
        className: 'is-active',
      },
    });
  });
}

// ============================================
// フロントページ TOPのサービス箇所
// ============================================
function txtAnim(){
  const txt = document.querySelector('.js-txtWrap');
  const txtItems = document.querySelectorAll('.js-txt');
  if (!txt || !txtItems) return;

  // PCのとき
  const isPC = window.matchMedia('(min-width: 768px)').matches;

  if(txt && txtItems){
    if(isPC){
      txtItems.forEach((txtItem, index) => {
        gsap.to(txtItem, {
          y: (100 + index * 50),
          delay: index * 0.2, // 0.2秒ずつずらす
          scrollTrigger: {
            // markers: true,
            trigger: txt,
            start: "8% center",
            end: "bottom center",
            scrub: true
          }
        });
      });
    } else {
      const yValues = [20, 38, 60, 85];
      txtItems.forEach((txtItem, index) => {
        gsap.to(txtItem, {
          y: yValues[index], // 規定の数字入れる
          delay: index * 0.2, // 0.2秒ずつずらす
          scrollTrigger: {
            // markers: true,
            trigger: txt,
            start: "center center",
            end: "bottom center",
            scrub: true
          }
        });
      });
    }
  }
}

// ============================================
// モックアップパララックス
// ============================================
function mocPara() {
  const imgPara = document.querySelectorAll('.js-parallax');
  const imgItems = document.querySelectorAll('.js-parallax__img');
  if (!imgPara || !imgItems) return;

  // PCのとき
  const isPC = window.matchMedia('(min-width: 768px)').matches;

  if(imgPara){
    if(isPC){
      imgPara.forEach(() => {
        imgItems.forEach((imgItem) => {
          gsap.to(imgItem, {
            top: '270px',
            scrollTrigger: {
              // markers: true,
              trigger: '.js-parallax',
              start: 'top center',
              end: 'bottom center',
              scrub: true,
            },
          });
        });
      });
    } else {
      imgPara.forEach(() => {
        imgItems.forEach((imgItem) => {
          gsap.to(imgItem, {
            top: '120px',
            scrollTrigger: {
              // markers: true,
              trigger: '.js-parallax',
              start: 'top center',
              end: 'bottom center',
              scrub: true,
            },
          });
        });
      });
    }
  }
}

// ============================================
// モックアップパララックス
// ============================================
function inviewAnim() {
  gsap.utils.toArray('.js-inviewAnim').forEach((el) => {
    ScrollTrigger.create({
      // markers: true,
      trigger: el,
      start: '30% center',
      end: 'bottom center',
      once: true,
      toggleClass: {
        targets: el,
        className: 'is-show',
      },
    });
  });
}

export { lenisPageScroll, inViewAnm , txtAnim, mocPara, inviewAnim };
